module.exports = __webpack_public_path__ + "static/media/AWS_BUILD_ON_ASEAN_2020.a35fb7df.png";